import React, { FC, useEffect, useState } from 'react';
import {shallowEqual, useSelector} from 'react-redux'
import { MovieDetail } from '../movieDetail/movieDetal';
import * as movie from '../../redux/MovieRedux'
import * as store from '../../../../setup'
let container = {
    display: "flex"
}
interface peli {
    data: any
}
const MoviesList: FC = () => {
    const [peliculas, setPeliculas] = useState<peli>({data:[]});
    const movies = useSelector<store.RootState>(({movie}) => movie.movies, shallowEqual)

    useEffect(() => {
        
        const timerId = setTimeout(() => {
            setPeliculas({data: movies})
        }, 500);
        return () => clearTimeout(timerId);
    }, [])
    if (peliculas.data.length===0) {
        return <><img src="https://c.tenor.com/tEBoZu1ISJ8AAAAC/spinning-loading.gif" alt="loading"/></>
    }
    else {
        return (
            <div style={container}>
                {
                    peliculas.data.map((items:any) => {
                        return <MovieDetail data={items} key={items.id} />
                    })
                }
            </div>
        )
    }
}
export { MoviesList }